import React from "react";
import Tooltip from "components/Tooltip";
import { useTranslation } from "react-i18next";
import { Materials2050EPDDetailOUT } from "api-client";

const GeneralInfo = ({
  details,
}: {
  details: Materials2050EPDDetailOUT | null;
}) => {
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";

  const generalInfo = [
    {
      title: "Version",
      value: "",
    },
    {
      title: t("productEditor.issuedOn"),
      value: details?.issued_at,
    },
    {
      title: t("productEditor.validUntil"),
      value: details?.valid_until,
    },
    {
      title: t("productEditor.epdType"),
      value: details?.epd_type,
    },
    {
      title: t("productEditor.registrationNumber"),
      value: details?.registration_number,
    },
    {
      title: t("productEditor.manufacturer"),
      value: details?.manufacturer,
    },
    {
      title: t("productEditor.database"),
      value: details?.database ?? t("productEditor.unknown"),
      tooltip: details?.database
        ? ""
        : t("productEditor.unknownDatabaseTooltip2050"),
    },
    {
      title: t("productEditor.materialConcular"),
      value:
        (isEng
          ? details?.concular_material_name_en
          : details?.concular_material_name_de) || t("productEditor.unknown"),
      tooltip: t("productEditor.materialConcularTooltip"),
    },
    {
      title: t("productEditor.materialCategory"),
      value: isEng
        ? details?.concular_material_category_name_en
        : details?.concular_material_category_name_de ||
          t("productEditor.unknown"),
      tooltip: t("productEditor.materialCategoryTooltip"),
    },
  ];

  return (
    <div className="mb-4">
      <div className="font-semibold text-base mb-3">
        {t("productEditor.generalInformation")}
      </div>
      <div className="flex items-center flex-wrap border-b border-gray-200 pb-2">
        {generalInfo.map((item, index) => (
          <div key={index} className="mr-4 mb-4">
            <div className="text-gray-800 text-sm font-medium flex">
              {item.title}
              {item.tooltip && (
                <Tooltip
                  content={item.tooltip}
                  iconClassName="!text-gray-500"
                ></Tooltip>
              )}
            </div>
            <div className="text-gray-500 text-sm">{item.value || "-"}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GeneralInfo;
